<template>
    <!-- 硬盘通用组件(所有云环境都有，主机管理以及资源组，用参数quote作为区分) -->
    <div class="module">
        <div class="module-container"
             :class="quote!='env'?'source':''">
            <rcTable ref="tableInstanceType"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
            </rcTable>
        </div>
    </div>
</template>
<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'harddisk',
    components: {
        rcTable
    },
    props: ['quote', 'id', 'envType', 'envName', 'region', 'baseInfo', 'isLocak', 'tableName', 'isMultiSelect'],
    data: function () {
        return {
            objType: 'disk',
            selected: [],
            columns: [
                {
                    title: this.$i18n.t('名称'),
                    key: 'name',
                    sortable: true,
                    sortKey: 'vdName',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.name } }, params.row.name)
                    }
                },
                {
                    title: this.$i18n.t('资源ID'),
                    key: 'uuid',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: false,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.uuid } }, params.row.uuid)
                    }
                },
                {
                    title: this.$i18n.t('存储类型'),
                    key: 'volumeType',
                    sortable: true,
                    sortKey: 'volumeTypeName',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true
                },
                {
                    title: this.$i18n.t('大小') + ' (GB)',
                    key: 'size',
                    sortable: true,
                    sortKey: 'allocateDiskSize',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', params.row.size)
                    }
                },
                {
                    title: this.$i18n.t('状态'),
                    key: 'status',
                    width: 100,
                    sortable: true,
                    sortKey: 'resVmId',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        let state = ''
                        let component = 'statusview'
                        const statusSure = ['creating', 'normal', 'setting', 'recovering', 'detaching', 'deleting', 'error-deleting', 'deleted', 'failure']
                        if (params.row.status === 'creating') {
                            state = '创建中'
                        } else if (params.row.status === 'setting') {
                            state = '配置中'
                        } else if (params.row.status === 'recovering') {
                            state = '恢复中'
                        } else if (params.row.status === 'normal' && params.row.resVmId !== '' && params.row.resVmId !== null) {
                            state = '使用中'
                        } else if (params.row.status === 'failure') {
                            state = '创建失败'
                            component = 'syncpoptip'
                        } else if (params.row.status === 'deleting') {
                            state = '销毁中'
                        } else if (params.row.status === 'deleted') {
                            state = '已删除'
                        } else if (params.row.status === 'normal' && (params.row.resVmId === '' || params.row.resVmId === null)) {
                            state = '未使用'
                        } else if (params.row.status === 'setting' || (params.row.attachments && params.row.attachments.length > 0)) {
                            state = params.row.attachments && params.row.attachments.length > 0 ? '卸载中' : '挂载中'
                        } else if (params.row.status === 'modifying') {
                            state = '修改中'
                        } else if (params.row.status === 'error') {
                            state = '错误'
                            component = 'syncpoptip'
                        } else if (params.row.status === 'detaching') {
                            state = '卸载中'
                        } else if (statusSure.indexOf(params.row.status) === -1) {
                            state = '其他'
                        } else if (params.row.status === 'error-deleting') {
                            state = '删除失败'
                            component = 'syncpoptip'
                        }
                        return h(component, {
                            props: component === 'syncpoptip' ? {
                                value: state,
                                params: {
                                    resType: 'vd',
                                    resSid: params.row.id
                                }
                            }
                                : {
                                    state: params.row.status,
                                    stateName: state
                                }
                        })
                    }
                },
                {
                    title: this.$i18n.t('硬盘属性'),
                    key: 'storagePurpose',
                    sortable: true,
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('div', [
                            h('span', { style: (params.row.storagePurpose === '01' ? 'display:inline-block' : 'display:none') }, '系统盘'),
                            h('span', { style: (params.row.storagePurpose === '02' ? 'display:inline-block' : 'display:none') }, '数据盘')
                        ])
                    }
                },
                {
                    title: this.$i18n.t('可用区'),
                    key: 'zoneName',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: false,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.zoneName } }, params.row.zoneName)
                    }
                },
                {
                    title: this.$i18n.t('挂载到'),
                    key: 'mountPoint',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: this.showTips(params.row.attachments, params.row.resVmId) } }, this.showTips(params.row.attachments, params.row.resVmId))
                    }
                },
                {
                    title: this.$i18n.t('共享'),
                    width: 50,
                    key: 'diskType',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        const text = params.row.diskType === 'share' ? '是' : '否'
                        return h('span', text)
                    }
                },
                {
                    title: this.$i18n.t('纳管时间'),
                    key: 'createdDt',
                    sortable: true,
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                    }
                },
                {
                    title: this.$i18n.t('结束时间'),
                    key: 'endTime',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: false,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.endTime } }, params.row.endTime)
                    }
                },
                {
                    title: this.$i18n.t('运行时长'),
                    key: 'time',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: false,
                    render: (h, params) => {
                        return h('span', { attrs: { title: this.parseDateDiff(params.row.startTime) } }, this.parseDateDiff(params.row.startTime))
                    }
                }
            ],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.VOLUMES, true),
                    params: {
                        envId: this.id,
                        notFailure: this.quote === 'host' ? 'failure' : undefined
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                searchColumns: [
                    {
                        key: 'nameLike',
                        title: this.$i18n.t('名称'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'status',
                        title: this.$i18n.t('状态'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: [
                            { name: '全部', value: 'null' },
                            { name: '创建中', value: 'creating' },
                            { name: '配置中', value: 'setting' },
                            { name: '恢复中', value: 'recovering' },
                            { name: '使用中', value: 'normal' },
                            { name: '创建失败', value: 'failure' },
                            { name: '销毁中', value: 'deleting' },
                            { name: '已删除', value: 'deleted' },
                            { name: '修改中', value: 'modifying' },
                            { name: '错误', value: 'error' },
                            { name: '删除错误', value: 'error-deleting' }
                            // { name: '挂载中', value: 'setting-mount' },
                            // { name: '卸载中', value: 'setting-unmount' },
                            // { name: '未使用', value: 'normal-unused' },
                            // { name: '使用中', value: 'normal-used' }
                        ]
                    }
                ],
                searchShow: true,
                tableSearchKey: this.tableName || '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: this.tableName || '', // 当作列选择的key存在
                isMultiSelect: this.isMultiSelect || !!((this.quote === 'env' && (this.envType === 'CloudOS' || this.envType === 'CloudOS-Admin'))),
                columnsChooseShow: true,
                columns: []
            }
        }
    },
    created () {
        switch (this.quote) {
            case 'env':
                this.handleDifEnv()
                break
            case 'source':
                this.editResource()
                break
            case 'host':
                this.handleHost()
                break
        }
    },
    computed: {
        showDestroy () {
            let res = false
            if (this.quote === 'env' && !['Azure', 'VMware', 'FusionCompute'].includes(this.envType)) {
                res = true
            }
            return res
        },
        // 销毁
        disabledDestroy () {
            let res = false
            if (this.selected.length === 0) {
                res = true
            }
            this.selected.forEach(obj => {
                if ((!((obj.resVmId === '' || obj.resVmId === null) && obj.storagePurpose !== '01') || obj.status === 'setting') && !['failure'].includes(obj.status)) {
                    res = true
                }
            })
            if (!this.hasPermission('MD1105')) {
                res = true
            }
            return res
        }
    },
    methods: {
        // 创建快照
        addSnapshot (row) {
            const routeData = this.$router.resolve({
                path: '/mgt/snapshots/create',
                query: {
                    resType: 'snapshot',
                    type: 'envCreate'
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 挂载云环境的展示内容
        showTips (attachments, resVmId) {
            if (resVmId !== null && resVmId !== undefined && resVmId !== '' && attachments instanceof Array) {
                return attachments.map(function (p1) {
                    if (p1.device !== null && p1.resVmName !== null) {
                        return '连接到' + p1.resVmName + '的设备' + p1.device + ''
                    } else if (p1.resVmName !== null) {
                        return '连接到' + p1.resVmName + '的根磁盘'
                    }
                }).join('&nbsp;|&nbsp;')
            }
            return ''
        },
        // 不同云环境下显示的表格列名不同（）
        handleDifEnv () {
            const type = this.envType
            this.tableAttr.columns = this.columns.slice(0)
            const length = this.tableAttr.columns.length
            this.tableAttr.searchColumns.splice(2, 1)
            if (['CloudOS', 'CloudOS-Admin'].includes(type)) {
                this.tableAttr.columns[6].title = '可用区别名'
                this.tableAttr.columns[6].render = (h, params) => {
                    return h('span', {
                        attrs: {
                            title: params.row.zoneLableName
                        }
                    }, params.row.zoneLableName)
                }
                this.tableAttr.searchColumns.push({
                    key: 'labelNameLike',
                    title: '可用区别名',
                    searchDefaultValue: ''
                })
            }
            this.tableAttr.columns[length - 1].render = (h, params) => {
                // let arr = []
                const row = params.row
                // 判断是否disabled
                let addsnapDisabel = false
                let mountDisabel = false
                // let destroyDisabel = false
                let deleteDisabel = false
                if (!((type !== 'VMware' && type !== 'PowerVC') ||
                    (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin'].includes(type) && (row.status !== 'normal' || row.storagePurpose !== '02'))) ||
                    (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin'].includes(this.envType) && params.row.storagePurpose === '01') ||
                    row.status !== 'normal') {
                    addsnapDisabel = true
                }
                if ((type === 'CloudOS' || type === 'CloudOS-Admin') && (params.row.storagePurpose === '01')) {
                    addsnapDisabel = true
                }
                if (!(row.storagePurpose !== '01' && (row.resVmId === '' || row.resVmId == null) && row.status === 'normal')) {
                    mountDisabel = true
                }

                if (!((params.row.resVmId === '' || params.row.resVmId === null) && params.row.storagePurpose !== '01') || params.row.status === 'setting') {
                    //  destroyDisabel = true
                }

                if (!(row.diskType !== 'local_ssd_pro' && row.storagePurpose !== '01' && row.resVmId !== '' && row.resVmId !== null && row.status === 'normal')) {
                    deleteDisabel = true
                }
                // 判断按钮
                let arr = []
                if (type.toLowerCase() === 'vmware') {
                    arr = [
                        h('a', {
                            on: { click: () => { !deleteDisabel && this.deleteFun(params.row) } },
                            class: {
                                disabledA: deleteDisabel || (!this.hasPermission('MD1104'))
                            }
                        }, '卸载')
                    ]
                } else {
                    // escloud、openstack系统盘不能创建快照,PowerVC不展示创建快照,状态为未使用不能创建快照
                    let Snapshot = ''
                    if (type !== 'PowerVC') {
                        Snapshot = h('a', {
                            on: { click: () => { !(addsnapDisabel || (!this.hasPermission('MD1106')) || (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'Qcloud', 'PowerVC'].includes(type) && params.row.storagePurpose === '01')) && this.addSnapshot(params.row) } },
                            class: {
                                disabledA: addsnapDisabel || (!this.hasPermission('MD1106')) || (['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'Qcloud', 'PowerVC'].includes(type) && params.row.storagePurpose === '01')
                            }
                        }, '创建快照')
                    }
                    arr = [
                        Snapshot,
                        h('a', {
                            on: { click: () => { !mountDisabel && this.mountFun(params.row) } },
                            class: {
                                disabledA: mountDisabel || (!this.hasPermission('MD1103'))
                            }
                        }, '挂载'),
                        // 任务2337 3所有操作最多显示3项，超过在更多显示
                        h('dropdownlist', {
                            props: {
                                operateConfig: this.configBtn(params.row)
                            },
                            style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                            on: { event: (type) => { this.operate(type, params.row) } }
                        })
                        // h('a', {
                        //     on: { click: () => { !destroyDisabel && this.destroyFun(params.row.id) } },
                        //     class: {
                        //         'disabledA': destroyDisabel || (!this.hasPermission('MD1105'))
                        //     }
                        // }, '销毁'),
                        // h('a', {
                        //     on: { click: () => { !deleteDisabel && this.deleteFun(params.row) } },
                        //     class: {
                        //         'disabledA': deleteDisabel || (!this.hasPermission('MD1104'))
                        //     }
                        // }, '卸载')
                    ]

                    if (type === 'FusionCompute') {
                        arr.splice(0, 1)
                    }
                }
                return h('div', {
                    class: 'tbl-operate'
                }, arr)
            }
            this.tableAttr.columns[0].render = (h, params) => {
                return h('a', {
                    on: {
                        click: () => { this.goDetails(params.row) }
                    },
                    attrs: { title: params.row.name }
                }, params.row.name)
            }
            // 查询保持
            this.tableAttr.searchDefaultValueList = []
            if (this.tableName && sessionStorage.ts_list && JSON.parse(sessionStorage.ts_list)[this.tableName]) {
                this.tableAttr.searchDefaultValueList = JSON.parse(sessionStorage.ts_list)[this.tableName]
            }
            if (type === 'VMware') {
                this.tableAttr.columns[length - 1].width = 120
            }
            if (type.toLowerCase() === 'fusioncompute') {
                this.tableAttr.columns.splice(length - 1, 1)
            }
            if (this.envType === 'Azure') {
                const length = this.tableAttr.columns.length
                this.tableAttr.columns.splice(length - 1, 1)
            }
            // 其他云环境排除共享列
            if (!['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'CloudOS', 'CloudOS-Admin'].includes(type)) {
                this.tableAttr.columns = this.tableAttr.columns.filter(elm => !(elm.key === 'diskType'))
            }
            // 硬盘可用区， CloudOS特有
            if (type === 'CloudOS') {
                this.tableAttr.columns[6].key = 'zoneLableName'
                this.tableAttr.columns[6].render = (h, params) => {
                    return h('span', {
                        attrs: {
                            title: params.row.zoneLableName
                        }
                    }, params.row.zoneLableName)
                }
            }
        },
        // 资源组下面使用该组件时对列表的修改
        editResource () {
            this.tableAttr.source.url = this.urlFormat(API.GET_RESGROUP_DISKS, true, [this.$route.params.id])
            const arr = this.columns.slice(0)
            arr[1].columnsChoosed = true
            arr.splice(2, 1)
            arr.splice(5, 8)
            const newArr = [{
                title: this.$i18n.t('所属实例'),
                key: 'resVmName',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true,
                render: (h, params) => {
                    return h('span', { attrs: { title: params.row.resVmName } }, params.row.resVmName)
                }
            },
            {
                title: this.$i18n.t('创建时间'),
                key: 'createdDt',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true,
                render: (h, params) => {
                    return h('span', { attrs: { title: params.row.createdDt } }, params.row.createdDt)
                }
            }]
            for (const item of newArr) {
                arr.push(item)
            }
            this.tableAttr.columns = arr
            this.tableAttr.columns[0] = {
                title: this.$i18n.t('名称'),
                key: 'resVmName',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true,
                render: (h, params) => {
                    return h('span', { attrs: { title: params.row.resVmName } }, params.row.resVmName)
                }
            }
            this.tableAttr.columns[2] = {
                title: this.$i18n.t('大小') + '( GB)',
                key: 'allocateDiskSize',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true,
                render: (h, params) => {
                    return h('span', params.row.allocateDiskSize)
                }
            }
        },
        // 硬盘 - 主机详情列表
        handleHost () {
            this.tableAttr.source.url = this.urlFormat(API.GET_HOST_STORAGE, true, [this.$route.params.id])
            this.tableAttr.wsKey = 'uuid'
            this.tableAttr.searchColumns.splice(1, 1)
            this.tableAttr.columns = [{
                title: this.$i18n.t('名称'),
                key: 'vdName',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true
            },
            {
                title: this.$i18n.t('资源ID'),
                key: 'uuid',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true
            }, {
                title: this.$i18n.t('大小GB'),
                key: 'allocateDiskSize',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true
            }, {
                title: this.$i18n.t('类型'),
                key: 'storagePurposeName',
                className: 'ellipsis',
                columnShow: true,
                disabledSearch: true,
                columnsChoosed: true
            }]
            // 创建中的
        },
        showBindWindow (id, tags) {
            this.$refs.bindTags.open(id, tags, this.objType)
        },
        refresh () {
            this.selected = []
            this.$refs.tableInstanceType.refreshTable()
        },
        parseDateDiff (created) {
            var dateConst = {
                minute: 1000 * 60,
                hour: 1000 * 60 * 60,
                day: 1000 * 60 * 60 * 24,
                year: 1000 * 60 * 60 * 24 * 365
            }
            if (!created) {
                return '--'
            }
            var now = new Date()
            var createdDate = new Date(created)
            var diff = now.getTime() - createdDate.getTime()
            if (diff < dateConst.minute) {
                return '刚刚'
            } else if (dateConst.minute <= diff && diff < dateConst.hour) {
                return Math.round(diff / dateConst.minute) + '分钟'
            } else if (dateConst.hour <= diff && diff < dateConst.day) {
                return Math.round(diff / dateConst.hour) + '小时'
            } else if (dateConst.day <= diff && diff < dateConst.year) {
                return Math.round(diff / dateConst.day) + '天'
            } else if (diff >= dateConst.year) {
                return Math.floor(diff / dateConst.year) + '年以上'
            }
        },
        goDetails (row) {
            this.$refs.diskhistory.openModal(row)
        }
    }
}
</script>
<style lang="less">
.hard-disk {
    .disabledA {
        color: #ccc !important;
        cursor: not-allowed !important;
    }
}
</style>

<style lang="less" scoped>
.hard-disk {
    .table-container.source {
        padding: 0;
    }
}
</style>
